var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconX = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M9.374 7.96A1 1 0 0 0 7.96 9.372L14.585 16 7.96 22.626a1 1 0 0 0 1.414 1.414L16 17.413l6.626 6.627a1 1 0 0 0 1.414-1.414l-6.626-6.627 6.625-6.626a1 1 0 0 0-1.414-1.414l-6.626 6.626z",
  clipRule: "evenodd"
})));
export default SvgIconX;